export const LIBRARY_NAME = '@wallaby-ui/document';
export const ERROR_MESSAGE_404 = 'Error: 404';

export default {LIBRARY_NAME};
